import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Hotel"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12.75 9.74995H18.75C20.8211 9.74995 22.5 11.4289 22.5 13.5V21.75H21V17.25H3V21.75H1.5V6.74995C1.50074 6.47351 1.65349 6.21988 1.8975 6.08995L11.6475 0.839953C11.8679 0.72262 12.1321 0.72262 12.3525 0.839953L22.1025 6.08995L21.3975 7.40995L12 2.35495L3 7.19995V15.75H11.25V11.25C11.25 10.4215 11.9216 9.74995 12.75 9.74995ZM12.75 11.25V15.75H21V13.5C21 12.2573 19.9926 11.25 18.75 11.25H12.75ZM7.125 11.2499C7.74632 11.2499 8.25 11.7536 8.25 12.3749C8.25 12.9963 7.74632 13.4999 7.125 13.4999C6.50368 13.4999 6 12.9963 6 12.3749C6 11.7536 6.50368 11.2499 7.125 11.2499ZM4.5 12.3749C4.5 10.9252 5.67525 9.74994 7.125 9.74994C8.57475 9.74994 9.75 10.9252 9.75 12.3749C9.75 13.8247 8.57475 14.9999 7.125 14.9999C5.67525 14.9999 4.5 13.8247 4.5 12.3749Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Hotel.vue"]]);
